import React from "react";
import { useHistory } from "react-router-dom";
import { Container, Box } from "@material-ui/core";
import { MinimalTopBar } from "components/MinimalTopBar";
import AnimationTest from "components/AnimationTest";

export default function AnimationTestView() {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Container maxWidth="sm">
      <MinimalTopBar onGoBack={handleGoBack} />
      <Box mt={3}>
        <AnimationTest />
      </Box>
    </Container>
  );
}